import * as ReactDOM from 'react-dom/client'
import { initializeApp } from 'firebase/app'
import * as firestore from 'firebase/firestore'

import { App } from './app'

const firebaseApp = initializeApp(__firebaseConfig__)
const db = firestore.getFirestore(firebaseApp)

const containerElement = document.getElementById('app')
const root = ReactDOM.createRoot(containerElement!)
root.render(<App firebaseApp={firebaseApp} db={db} />)
